import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const DeleteWarningModal = ({ 
    visible, 
    onClose, 
    clusterData,
    isRTL,
    dmode 
}) => {
    const { t } = useTranslation();
    const hasStores = clusterData?.stores && clusterData.stores.length > 0;
    const hasLinkedArray = clusterData?.linkArrayName && clusterData.linkArrayName !== null && clusterData.linkArrayName !== 'None';

    const getWarningReasons = () => {
        const reasons = [];
        if (hasStores) {
            reasons.push(t('ASSOCIATED_WITH_STORES', { count: clusterData.stores.length }));
        }
        if (hasLinkedArray) {
            reasons.push(t('LINKED_TO_ARRAY', { arrayName: clusterData.linkArrayName }));
        }
        return reasons;
    };

    return (
        <Modal
            title={
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    fontFamily: 'Mulish, sans-serif',
                    fontWeight: '700',
                    color: dmode ? '#ccc' : '#333333'
                }}>
                    <ExclamationCircleOutlined style={{ color: '#FF8C00', fontSize: '18px' }} />
                    {t('CANNOT_DELETE_CLUSTER')}
                </div>
            }
            open={visible}
            onCancel={onClose}
            centered
            width={450}
            footer={null}
            maskClosable={true}
            closable={true}
            bodyStyle={{ 
                padding: '24px',
                fontFamily: 'Mulish, sans-serif',
                backgroundColor: dmode ? '#2f353e' : '#fff'
            }}
            style={{
                direction: isRTL ? 'rtl' : 'ltr'
            }}
            styles={{
                header: {
                    backgroundColor: dmode ? '#2f353e' : '#fff',
                    borderBottom: 'none'
                },
                body: {
                    backgroundColor: dmode ? '#2f353e' : '#fff'
                },
                content: {
                    backgroundColor: dmode ? '#2f353e' : '#fff'
                }
            }}
        >
            <div style={{ marginBottom: '24px' }}>
                <p style={{ 
                    fontSize: '14px', 
                    color: dmode ? '#999' : '#666666', 
                    marginBottom: '16px',
                    lineHeight: '1.5'
                }}>
                    {t('CLUSTER_CANNOT_DELETE_DEPENDENCIES')}
                </p>
                
                {clusterData && (
                    <div style={{
                        backgroundColor: dmode ? '#3a4149' : '#F8F9FA',
                        padding: '16px',
                        borderRadius: '8px',
                        border: dmode ? '1px solid #555' : '1px solid #E9ECEF',
                        marginBottom: '16px'
                    }}>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontWeight: '600', color: dmode ? '#ccc' : '#333333' }}>{t('CLUSTER_NAME')}: </span>
                            <span style={{ color: dmode ? '#999' : '#666666' }}>{clusterData.clusterName}</span>
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ fontWeight: '600', color: dmode ? '#ccc' : '#333333' }}>{t('CODE')}: </span>
                            <span style={{ color: dmode ? '#999' : '#666666' }}>{clusterData.code || clusterData.clusterCode}</span>
                        </div>
                    </div>
                )}

                <div style={{
                    marginBottom: '16px',
                    padding: '12px',
                    backgroundColor: dmode ? '#5c4a2f' : '#FFF8E1',
                    border: dmode ? '1px solid #b8860b' : '1px solid #FFE082',
                    borderRadius: '6px',
                    fontSize: '13px',
                    color: dmode ? '#ffcc80' : '#E65100'
                }}>
                    <strong>{t('DEPENDENCIES_PREVENTING_DELETION')}:</strong>
                    <ul style={{ margin: '8px 0 0 20px', padding: 0 }}>
                        {getWarningReasons().map((reason, index) => (
                            <li key={index} style={{ marginBottom: '4px' }}>{reason}</li>
                        ))}
                    </ul>
                </div>
            </div>

            <div style={{ 
                display: 'flex', 
                justifyContent: 'flex-end', 
                gap: '12px'
            }}>
                <Button
                    type="primary"
                    onClick={onClose}
                    style={{
                        backgroundColor: '#1890ff',
                        borderColor: '#1890ff',
                        fontFamily: 'Mulish, sans-serif',
                        fontWeight: '600',
                        height: '36px',
                        minWidth: '100px'
                    }}
                >
                    {t('UNDERSTOOD')}
                </Button>
            </div>
        </Modal>
    );
};

export default DeleteWarningModal;